import { useState } from "react";
import TextAreaInput from "../../components/TextAreaInput";
import BaseSection from "../BaseSection";
import { Container } from "./styles";
import { SURVEY_FORM_FIELDS } from "../../../constants";

export default function SurveyInfoSection({ values = {}, onChangeValue = () => null}) {
  const defaultData = {
    [SURVEY_FORM_FIELDS.TITLE]: values[SURVEY_FORM_FIELDS.TITLE] || '',
    [SURVEY_FORM_FIELDS.DESCRIPTION]: values[SURVEY_FORM_FIELDS.DESCRIPTION] || ''
  };

  const [data, setData] = useState(defaultData);
  const [isEditting, setIsEditting] = useState(false);

  const toggleIsEditting = () => {
    setIsEditting((prev) => !prev);
  };

  const handleSave = () => {
    onChangeValue(SURVEY_FORM_FIELDS.TITLE, data[SURVEY_FORM_FIELDS.TITLE]);
    onChangeValue(SURVEY_FORM_FIELDS.DESCRIPTION, data[SURVEY_FORM_FIELDS.DESCRIPTION]);
    toggleIsEditting();
  };

  const handleCancel = () => {
    setData(defaultData);
    toggleIsEditting();
  };

  const handleChangeData = (key, value) => {
    setData(prev => ({...prev, [key]: value}));
  }

  return (
    <BaseSection
      allowEdit
      isEditting={isEditting}
      onToggleIsEditting={toggleIsEditting}
      onCancelEditting={handleCancel}
      onSubmitEditting={handleSave}
    >
      <Container>
        <TextAreaInput
          fontSize="1.75rem"
          fontWeight="700"
          placeholder="Digite o Título"
          readOnly={!isEditting}
          value={data[SURVEY_FORM_FIELDS.TITLE]}
          onChange={e => handleChangeData(SURVEY_FORM_FIELDS.TITLE, e.target.value)}
        />
        <TextAreaInput
          fontSize="1rem"
          placeholder="Digite a descrição"
          readOnly={!isEditting}
          value={data[SURVEY_FORM_FIELDS.DESCRIPTION]}
          onChange={e => handleChangeData(SURVEY_FORM_FIELDS.DESCRIPTION, e.target.value)}
        />
      </Container>
    </BaseSection>
  );
}
